export default __webpack_public_path__ + "static/media/batons_cadense_01.eb90f15f.gif";